export const EDIT_PASSPORT_INFO_REQUEST = 'EDIT_PASSPORT_INFO_REQUEST'
export const EDIT_PASSPORT_INFO_SUCCESS = 'EDIT_PASSPORT_INFO_SUCCESS'
export const EDIT_PASSPORT_INFO_FAIL = 'EDIT_PASSPORT_INFO_FAIL'
export const EDIT_PASSPORT_INFO_RESET = 'EDIT_PASSPORT_INFO_RESET'
